import { styled, Theme } from "@mui/material/styles";

const Offset = styled("div")(
  ({ theme }: { theme: Theme }) => theme.mixins.toolbar
);

export default Offset;
